import { useEffect } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { CANVAS_SIZE_ID } from "../Canvas/constants";
import { IFRAME_ID } from "../Frames/constants";
import { useDropZoneRecalculation } from "../Hooks/useDropZoneRecalculation";
import { useIFrameDocument } from "../Hooks/useIFrameDocument";

const DELAY = 200;

export const DropZoneController = () => {
  const { debouncedRecalculatePositions, recalculatePositions } =
    useDropZoneRecalculation();
  const dragAndDropType = useBuilderStore(state => state.dragAndDropType);
  const pages = useBuilderStore(state => state.pages);
  const iFrameDocument = useIFrameDocument(IFRAME_ID, JSON.stringify(pages));

  useEffect(() => {
    if (dragAndDropType !== "floating-dropzones") return undefined;

    const canvasSizeElement = document.getElementById(CANVAS_SIZE_ID);
    const iframeElement = document.getElementById(IFRAME_ID);

    if (!iFrameDocument || !canvasSizeElement || !iframeElement)
      return undefined;

    const handleIframeLoad = () => {
      setTimeout(() => {
        recalculatePositions();
      }, DELAY);
    };

    const resizeObserver = new ResizeObserver(debouncedRecalculatePositions);

    iframeElement.addEventListener("load", handleIframeLoad);
    iFrameDocument.addEventListener("scroll", debouncedRecalculatePositions);
    resizeObserver.observe(canvasSizeElement);

    const blockElements = Array.from(
      iFrameDocument.querySelectorAll("[data-measurable-block]"),
    );
    blockElements.forEach(element => resizeObserver.observe(element));

    const imageElements = Array.from(
      iFrameDocument.querySelectorAll("[data-measurable-block] img"),
    );
    imageElements.forEach(img =>
      img.addEventListener("load", debouncedRecalculatePositions),
    );

    return () => {
      iframeElement.removeEventListener("load", handleIframeLoad);
      iFrameDocument.removeEventListener(
        "scroll",
        debouncedRecalculatePositions,
      );
      resizeObserver.disconnect();
      imageElements.forEach(img =>
        img.removeEventListener("load", debouncedRecalculatePositions),
      );
    };
  }, [
    iFrameDocument,
    dragAndDropType,
    debouncedRecalculatePositions,
    recalculatePositions,
  ]);

  return null;
};
